(() => {
    let registerContainer, token, url, quiz, game, termsUrl, gdprUrl;
    let body, overlay, box, bolded, msgText, close;
    let usernameValid = false;
    let emailValid = false;
    let termsChecked = false;
    let gdprChecked = false;

    const init = () => {
        const quizForm = document.getElementById('quiz-game');
        registerContainer = document.getElementById('register-container');

        if (!quizForm || !registerContainer) {
            return false;
        }
        token = registerContainer.getAttribute('data-token');
        url = registerContainer.getAttribute('data-url');
        quiz = registerContainer.getAttribute('data-quiz');
        game = registerContainer.getAttribute('data-game');
        gdprUrl = registerContainer.getAttribute('data-gdpr');
        termsUrl = registerContainer.getAttribute('data-terms');
        close = document.createElement('span');
        close.setAttribute('class', 'close-modal');

        quizForm.addEventListener('submit', quizFormHandle);
        prepareMessageBox();
    };

    const prepareMessageBox = () => {
        body = document.querySelector('body');
        overlay = document.createElement('div');
        box = document.createElement('div');
        bolded = document.createElement('strong');
        msgText = document.createElement('p');

        overlay.setAttribute('class', 'fvp-overlay');
        box.setAttribute('class', 'message');
        box.appendChild(close);
        overlay.appendChild(box);
    };

    const quizFormHandle = (e) => {
        e.preventDefault();
        const selectedAnswer = document.querySelector('input[type=radio]:checked');
        if (!selectedAnswer) {
            renderMessage('Моля изберете отговор', '', true);
            return;
        }
        const isCorrect = selectedAnswer.getAttribute('data-correct');
        if (0 === parseInt(isCorrect)) {
            renderMessage('Грешен отговор.', 'Опитайте отново!', true);
            return;
        }

        openRegistrationForm();
    };

    const openRegistrationForm = () => {
        registerContainer.innerHTML = '';
        const form = document.createElement('form');
        form.setAttribute('id', 'register-container');

        let close = document.createElement('span');
        close.setAttribute('class', 'close-modal');

        const container = document.createElement('div');
        container.setAttribute('class', 'container');

        const headerText = document.createElement('h1');
        headerText.innerText = 'Регистрация';

        const addText = document.createElement('p');
        addText.innerText =
            'Всяка допълнителна регистрация увеличава твоя шанс да спечелиш една от нашите страхотни награди.';

        const overlay = document.createElement('div');
        overlay.setAttribute('class', 'fvp-overlay');

        const nameInput = document.createElement('input');
        nameInput.placeholder = 'Име и фамилия';
        nameInput.name = 'username';
        nameInput.addEventListener('change', (e) => validateInput('username', e));

        const emailInput = document.createElement('input');
        emailInput.placeholder = 'e-mail';
        emailInput.name = 'email';
        emailInput.addEventListener('change', (e) => validateInput('email', e));

        const termsContainer = document.createElement('div');
        termsContainer.setAttribute('class', 'conditions-container');
        const termsCheck = document.createElement('input');
        termsCheck.type = 'checkbox';
        termsCheck.id = 'terms';
        termsCheck.name = 'terms';
        termsCheck.addEventListener('change', (e) => validateInput('terms', e));
        const termsLabel = document.createElement('label');
        termsLabel.setAttribute('for', 'terms');
        termsLabel.innerHTML = `Съгласен съм с <a class="terms-highlight" href="${termsUrl}" target="_blank"> ОБЩИТЕ УСЛИВИЯ </a> на играта`;
        termsContainer.appendChild(termsCheck);
        termsContainer.appendChild(termsLabel);

        const gdprContainer = document.createElement('div');
        gdprContainer.setAttribute('class', 'conditions-container');
        const gdpr = document.createElement('input');
        gdpr.type = 'checkbox';
        gdpr.id = 'gdpr';
        gdpr.name = 'gdpr';
        gdpr.addEventListener('change', (e) => validateInput('gdpr', e));
        const gdprLabel = document.createElement('label');
        gdprLabel.setAttribute('for', 'gdpr');
        gdprLabel.innerHTML = `Приемам личните ми данни да бъдат обработвани от лицата, за целите и по начина, посочени <a class="terms-highlight" href="${gdprUrl}" target="_blank">тук</a>`;
        gdprContainer.appendChild(gdpr);
        gdprContainer.appendChild(gdprLabel);

        const submitBtn = document.createElement('button');
        submitBtn.type = 'submit';
        submitBtn.innerHTML = 'Регистрация';

        form.addEventListener('submit', handleRegister);

        form.appendChild(nameInput);
        form.appendChild(emailInput);
        form.appendChild(termsContainer);
        form.appendChild(gdprContainer);
        form.appendChild(submitBtn);

        container.appendChild(headerText);
        container.appendChild(addText);
        container.appendChild(form);
        overlay.appendChild(close);
        overlay.appendChild(container);

        modalClose(close, overlay);

        registerContainer.appendChild(overlay);
    };

    const handleRegister = (e) => {
        e.preventDefault();
        if (!usernameValid || !emailValid || !termsChecked || !gdprChecked) {
            renderMessage('Възникна грешка при регистрацията!', 'Моля попълнете всички полета.', true);
            return;
        }

        const username = e.target.username.value;
        const email = e.target.email.value;
        const terms = e.target.terms.checked;
        const gdpr = e.target.gdpr.checked;

        const submitData = {
            username,
            email,
            quiz,
            token,
            game,
            terms,
            gdpr,
        };

        requestService(submitData);
    };

    const validateInput = (rule, event) => {
        if ('username' === rule) {
            if (event.target.value.length < 5) {
                event.target.style = 'border:1px solid red;';
                usernameValid = false;
            } else {
                event.target.style = '';
                usernameValid = true;
            }
        }

        if ('email' === rule) {
            if (!/(.+)@(.+){2,}\.(.+){2,}/.test(event.target.value)) {
                event.target.style = 'border:1px solid red;';
                emailValid = false;
            } else {
                event.target.style = '';
                emailValid = true;
            }
        }

        if ('terms' === rule) {
            if (!event.target.checked) {
                event.target.style = 'border:1px solid red;';
                termsChecked = false;
            } else {
                event.target.style = '';
                termsChecked = true;
            }
        }

        if ('gdpr' === rule) {
            if (!event.target.checked) {
                event.target.style = 'border:1px solid red;';
                gdprChecked = false;
            } else {
                event.target.style = '';
                gdprChecked = true;
            }
        }
    };

    const requestService = (data) => {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((data) => {
                if (false === data.error) {
                    renderMessage('Успешна регистрация!', 'Благодарим за вашето участие.', false);
                } else {
                    renderMessage('Възникна грешка при регистрацията!', 'Моля опитайте отново.', true);
                }
            })
            .catch((error) => {
                renderMessage('Възникна грешка при регистрацията!', 'Моля опитайте отново.', true);
            });
    };

    const renderMessage = (boldMsg, textMsg, isError = false) => {
        const status = isError ? '--error' : '--success';
        box.classList.add(status);
        bolded.innerText = boldMsg;
        msgText.innerText = textMsg;

        box.appendChild(bolded);
        box.appendChild(msgText);
        body.appendChild(overlay);
        modalClose(close, overlay);
    };

    const modalClose = (el, parent) => {
        el.addEventListener('click', () => {
            if (parent.querySelector('.--success')) {
                let overlays = document.querySelectorAll('.fvp-overlay');
                overlays.forEach((el) => {
                    return el.remove();
                });
            }
            parent.remove();
        });
    };

    init();
})();
